export default __webpack_public_path__ + "static/media/beraksi-phone4.8844289a.png";